var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLdlExperienceBusRev0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9443",
    "data-name": "Grupo 9443",
    transform: "translate(-261 -3941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4587",
    "data-name": "Ret\\xE2ngulo 4587",
    width: 99,
    height: 99,
    rx: 16,
    transform: "translate(261 3941)",
    fill: "#3b3b3b",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9236",
    "data-name": "Grupo 9236",
    transform: "translate(262 3919.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9236-2",
    "data-name": "Grupo 9236",
    transform: "translate(15 40.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5254",
    "data-name": "Caminho 5254",
    d: "M72.981,53.179H64.415V50.544h1.318a1.318,1.318,0,0,0,1.318-1.318V41.32A1.318,1.318,0,0,0,65.733,40H31.472a1.318,1.318,0,0,0-1.318,1.318v7.906a1.318,1.318,0,0,0,1.318,1.318H32.79v2.635H24.224A9.235,9.235,0,0,0,15,62.4V96.665a1.318,1.318,0,0,0,1.318,1.318H22.91a6.582,6.582,0,0,0,10.535,0H63.76a6.582,6.582,0,0,0,10.535,0h6.592a1.318,1.318,0,0,0,1.318-1.318V62.4A9.235,9.235,0,0,0,72.981,53.179ZM79.57,74.263H75.616V66.357H79.57ZM32.79,42.637H64.415v5.271H32.79Zm2.635,7.906H61.78v2.635H35.425Zm-11.2,5.271H72.981A6.6,6.6,0,0,1,79.57,62.4v1.318H74.3a1.318,1.318,0,0,0-1.318,1.318V75.581A1.318,1.318,0,0,0,74.3,76.9H79.57V90.076H74.3a6.582,6.582,0,0,0-10.535,0H33.445a6.582,6.582,0,0,0-10.535,0H17.635V62.4A6.6,6.6,0,0,1,24.224,55.815ZM17.635,95.347V92.712h4.086a6.615,6.615,0,0,0,0,2.635Zm10.542,2.635a3.953,3.953,0,1,1,3.953-3.953A3.958,3.958,0,0,1,28.177,97.983Zm6.456-2.635a6.615,6.615,0,0,0,0-2.635H62.571a6.613,6.613,0,0,0,0,2.635Zm34.394,2.635a3.953,3.953,0,1,1,3.953-3.953A3.958,3.958,0,0,1,69.028,97.983Zm6.456-2.635a6.613,6.613,0,0,0,0-2.635H79.57v2.635Z",
    transform: "translate(-15 -40.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5255",
    "data-name": "Caminho 5255",
    d: "M111.318,206.357H150.85a1.318,1.318,0,0,0,1.318-1.318V181.32A1.318,1.318,0,0,0,150.85,180H111.318A1.318,1.318,0,0,0,110,181.32v23.719A1.318,1.318,0,0,0,111.318,206.357Zm7.217-5.271h14.556l-1.054,2.636H119.589Zm2.007-2.636a6.592,6.592,0,0,1,10.542,0Zm21.084,5.271v-2.636h2.635v2.636Zm5.271,0v-3.953a1.318,1.318,0,0,0-1.318-1.318h-1.318V194.5a1.318,1.318,0,0,0-1.318-1.318h-2.635a1.318,1.318,0,1,0,0,2.635h1.318v2.635h-1.318a1.318,1.318,0,0,0-1.318,1.318v3.953h-4.115l1.385-3.464a1.319,1.319,0,0,0-1.224-1.807h-.89a9.224,9.224,0,0,0-16.668,0h-.89a1.319,1.319,0,0,0-1.224,1.807l1.385,3.464h-4.115V189.835a5.257,5.257,0,0,0,6.589-1.081,5.26,5.26,0,0,0,7.906,0,5.26,5.26,0,0,0,7.906,0,5.26,5.26,0,0,0,7.906,0,5.257,5.257,0,0,0,6.589,1.081v13.887Zm2.635-18.448a2.635,2.635,0,0,1-5.271,0v-2.636h5.271Zm-7.906,0a2.635,2.635,0,0,1-5.271,0v-2.636h5.271Zm-7.906,0a2.635,2.635,0,0,1-5.271,0v-2.636h5.271Zm-7.906,0a2.635,2.635,0,0,1-5.271,0v-2.636h5.271Zm-13.177-2.636h5.271v2.636a2.635,2.635,0,0,1-5.271,0Z",
    transform: "translate(-97.481 -161.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    cx: 1.177,
    cy: 1.177,
    r: 1.177,
    transform: "translate(11.768 52.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 1.177,
    cy: 1.177,
    r: 1.177,
    transform: "translate(52.958 52.958)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLdlExperienceBusRev0);
export default __webpack_public_path__ + "static/media/icon-ldl-experience-bus-rev0.31427d47f9f7238b6ad10699112c8e32.svg";
export { ForwardRef as ReactComponent };